var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.502C17.5228 22.502 22 18.0248 22 12.502C22 6.97911 17.5228 2.50195 12 2.50195C6.47715 2.50195 2 6.97911 2 12.502C2 18.0248 6.47715 22.502 12 22.502ZM10.6935 16.3478L15.4137 13.5609C16.1954 13.0994 16.1954 11.9045 15.4137 11.443L10.6935 8.65614C9.93371 8.20756 9 8.79143 9 9.71511V15.2888C9 16.2125 9.93371 16.7963 10.6935 16.3478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.b058019aef8c2eecba1d2e3759474ba2.svg";
export { ForwardRef as ReactComponent };